import { inject, Injectable, signal } from '@angular/core';
import { EMPTY, fromEvent, timer } from 'rxjs';
import { map, startWith, switchMap } from 'rxjs/operators';
import { LocalStorage } from '../storage.class';
import { AuthorisationService } from './auth/authorisation.service';
import { Functionalities } from './auth/functionalities';
import { ChecklistService } from './checklist.service';

// 5 minuten
const SIGN_OFF_POLL_INTERVAL_MS = 300000;
const SIGN_OFF_INITIAL_DELAY_MS = 1000;

@Injectable({
    providedIn: 'root',
})
export class ChecklistSignOffService {
    readonly hasPendingSignOff = signal(false);

    private checklistService = inject(ChecklistService);

    constructor() {
        if (AuthorisationService.hasFunctionality(Functionalities.ChecklistSignOff)) {
            fromEvent(document, 'visibilitychange')
                .pipe(
                    startWith(null),
                    map(() => document.visibilityState === 'visible'),
                    switchMap(isVisible =>
                        isVisible ? timer(SIGN_OFF_INITIAL_DELAY_MS, SIGN_OFF_POLL_INTERVAL_MS) : EMPTY
                    )
                )
                .subscribe(() => this.refresh());
        }
    }

    refresh() {
        const currentUserId = LocalStorage.getUser()?.id;
        if (!currentUserId || !AuthorisationService.hasFunctionality(Functionalities.ChecklistSignOff)) {
            this.hasPendingSignOff.set(false);
            return;
        }

        this.checklistService.hasPendingSignOff().subscribe(response => {
            this.hasPendingSignOff.set(response.data);
        });
    }
}
